import React from 'react'

const ModuleDisplayURL = ({ value }) => {
    return (
        <a href={value} target="_blank"> {value}</a>
    )
}

export default ModuleDisplayURL